import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Box, CircularProgress } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import '../css/PostedBlogs.css';
const PostedBlogs = () => {
  const [blogs, setBlogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  const [editingBlog, setEditingBlog] = useState(null); // for modal open
  const [editedTitle, setEditedTitle] = useState('');
  const [editedDescription, setEditedDescription] = useState('');

  const [viewingBlog, setViewingBlog] = useState(null);

  useEffect(() => {
    const fetchBlogs = async () => {
      try {
        const res = await axios.get('/api/bloglist');
        setBlogs(res.data);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching members:", error);
        setLoading(false);
      }
    };

    fetchBlogs();
  }, []);

    const handleViewBlog = (blog) => {
    setViewingBlog(blog);
  };


  const handleEditBlog = (id) => {
    const blogToEdit = blogs.find((blg) => blg._id === id);
    setEditingBlog(blogToEdit);
    setEditedTitle(blogToEdit.title);
    setEditedDescription(blogToEdit.description);
  };
  
  const handleSaveEdit = async () => {
    if (!editingBlog) return;
  
    try {
      const response = await fetch(`/api/blogs/${editingBlog._id}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          title: editedTitle,
          description: editedDescription,
        }),
      });
  
      const data = await response.json();
      if (response.ok) {
        // Update frontend instantly
        setBlogs((prevBlogs) =>
          prevBlogs.map((blg) =>
            blg._id === editingBlog._id ? { ...blg, title: editedTitle, description: editedDescription } : blg
          )
        );
        setEditingBlog(null);
        alert(data.message);
      } else {
        alert(data.message || 'Failed to update blog');
      }
    } catch (error) {
      console.error('Error updating blog:', error);
      alert('Error updating blog');
    }
  };
  
  
    // Handle individual video delete
      const handleDeleteBlog = async (blgId) => {
        
        const confirmed = window.confirm(`Are you sure you want to delete?`);
        if (!confirmed) return;
        try {
        const res = await axios.delete(`/api/deleteblog/${blgId}`);
        console.log('Deleted blog:', res.data);
        setBlogs(prev => prev.filter(blg => blg._id !== blgId));
         } catch (error) {
        console.error('Error deleting blog:', error.response?.data?.message || error.message);
        alert(`Failed to delete blog: ${error.response?.data?.message || error.message}`);
      }
    
      };

   const truncateText = (text, lines = 2) => {
    if (!text) return '';
    const words = text.split(' ');
    const approxWordsPerLine = 15;
    const maxWords = lines * approxWordsPerLine;
    if (words.length <= maxWords) return text;
    return words.slice(0, maxWords).join(' ') + '...';
  };

  // if (loading) return <CircularProgress />;
  
  if (loading) {
    return (
      <Box className="ptblg-loading">
        <CircularProgress />
      </Box>
    );
  }
return (
    <Box className="ptblg-container">
      <div className='ptblg-header'>
        <div>
          <h1 className='ptblg-page-title'>Blog Management</h1>
          <p className='ptblg-subtitle'>{blogs.length} {blogs.length === 1 ? 'blog' : 'blogs'} published</p>
        </div>
        <button className='ptblg-add-button' onClick={() => navigate('/dashboard/blogs/addblog')}>
          <svg className="ptblg-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
          </svg>
          Add New Blog
        </button>
      </div>

      {blogs.length === 0 ? (
        <div className="ptblg-empty-state">
          <svg className="ptblg-empty-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 20H5a2 2 0 01-2-2V6a2 2 0 012-2h10a2 2 0 012 2v1m2 13a2 2 0 01-2-2V7m2 13a2 2 0 002-2V9a2 2 0 00-2-2h-2m-4-3H9M7 16h6M7 8h6v4H7V8z" />
          </svg>
          <h3 className="ptblg-empty-title">No blogs yet</h3>
          <p className="ptblg-empty-text">Start creating engaging content for your audience</p>
          <button className='ptblg-add-button ptblg-empty-button' onClick={() => navigate('/dashboard/blogs/addblog')}>
            Create Your First Blog
          </button>
        </div>
      ) : (
        <div className="ptblg-gallery-grid">
          {blogs.map((blg) => (
            <div key={blg._id} className="ptblg-card" onClick={() => handleViewBlog(blg)}>
              <div className="ptblg-image-wrapper">
                <img
                  src={blg.imageUrl}
                  alt={blg.title}
                  className="ptblg-image"
                />
                <div className="ptblg-overlay">
                  <span className="ptblg-read-more">Read More →</span>
                </div>
              </div>
              <div className="ptblg-card-content">
                <div className="ptblg-card-header">
                  <h3 className="ptblg-card-title">{blg.title}</h3>
                </div>
                <p className="ptblg-card-description">{truncateText(blg.description, 2)}</p>
                <div className="ptblg-card-footer">
                  <span className="ptblg-date">{blg.date}</span>
                  <div className="ptblg-action-buttons" onClick={(e) => e.stopPropagation()}>
                    <button 
                      className="ptblg-edit-btn"
                      onClick={(e) => {
                        e.stopPropagation();
                        handleEditBlog(blg._id);
                      }}
                      title="Edit Blog"
                    >
                      <svg className="ptblg-btn-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                      </svg>
                    </button>
                    <button 
                      className="ptblg-delete-btn"
                      onClick={(e) => {
                        e.stopPropagation();
                        handleDeleteBlog(blg._id);
                      }}
                      title="Delete Blog"
                    >
                      <svg className="ptblg-btn-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                      </svg>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}

      {/* View Blog Modal */}
      {viewingBlog && (
        <div className="ptblg-modal-overlay" onClick={() => setViewingBlog(null)}>
          <div className="ptblg-modal-content ptblg-view-modal" onClick={(e) => e.stopPropagation()}>
            <button className="ptblg-modal-close" onClick={() => setViewingBlog(null)}>
              <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
            <img
              src={viewingBlog.imageUrl}
              alt={viewingBlog.title}
              className="ptblg-modal-image"
            />
            <div className="ptblg-modal-body">
              <h2 className="ptblg-modal-title">{viewingBlog.title}</h2>
              <span className="ptblg-modal-date">{viewingBlog.date}</span>
              <p className="ptblg-modal-description">{viewingBlog.description}</p>
              <div className="ptblg-modal-actions">
                <button className="ptblg-edit-btn-modal" onClick={() => handleEditBlog(viewingBlog._id)}>
                  <svg className="ptblg-btn-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                  </svg>
                  Edit Blog
                </button>
                <button className="ptblg-delete-btn-modal" onClick={() => handleDeleteBlog(viewingBlog._id)}>
                  <svg className="ptblg-btn-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                  </svg>
                  Delete
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Edit Blog Modal */}
      {editingBlog && (
        <div className="ptblg-modal-overlay" onClick={() => setEditingBlog(null)}>
          <div className="ptblg-modal-content ptblg-edit-modal" onClick={(e) => e.stopPropagation()}>
            <button className="ptblg-modal-close" onClick={() => setEditingBlog(null)}>
              <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
            <h2 className="ptblg-modal-title">Edit Blog</h2>
            <img
              src={editingBlog.imageUrl}
              alt={editingBlog.title}
              className="ptblg-modal-image-preview"
            />
            <div className="ptblg-form-group">
              <label className="ptblg-label">Title</label>
              <input
                type="text"
                value={editedTitle}
                onChange={(e) => setEditedTitle(e.target.value)}
                className="ptblg-input"
                placeholder="Enter blog title"
              />
            </div>
            <div className="ptblg-form-group">
              <label className="ptblg-label">Description</label>
              <textarea
                value={editedDescription}
                onChange={(e) => setEditedDescription(e.target.value)}
                className="ptblg-textarea"
                placeholder="Enter blog description"
                rows="8"
              />
            </div>
            <div className="ptblg-modal-actions">
              <button className="ptblg-save-btn" onClick={handleSaveEdit}>
                Save Changes
              </button>
              <button className="ptblg-cancel-btn" onClick={() => setEditingBlog(null)}>
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
    </Box>
  );
};
//   return (
//     <Box className="ptblgcontainer">
//           <div className='ptblgheader'>
//             <h1 className='ptblgpageTitle'>Blog Management</h1>
//             <button className='ptblgaddButton' onClick={() => navigate('/dashboard/blogs/addblog')}>
//               <svg className="ptblgicon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                 <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
//               </svg>
//               Add Blog
//             </button>
//           </div>
    
         
    
//           {blogs.length === 0 ? (
//             <div className="ptblgemptyState">
//               <svg className="ptblgemptyIcon"  fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                 <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
//               </svg>
//               <h3 className="ptblgemptyTitle">No blogs yet</h3>
//               <p className="ptblgemptyText">Start by adding your first blog</p>
//             </div>
//           ) : (
//             <div className="ptblggalleryGrid">
//               {blogs.map((blg, index) => (
//                 <div 
//                   key={blg._id} 
                  
//                 >
//                   <div className="ptblgimageWrapper">
//                     <img
//                       src={blg.imageUrl}
//                       alt={blg.title}
//                       //style={styles.galleryImage}
//                       className="ptblggalleryImage"
//                     />
//                   </div>
//                   <div className="ptblgcardContent">
//             <div className="ptblgcardHeader">
//               <h3 className="ptblgcardTitle">{blg.title}</h3>
//               <div className="ptblgactionButtons">
//                         <button 
//                           //style={styles.editBtn}
//                           className="ptblgeditBtn"
//                           onClick={(e) => handleEditBlog(blg._id)}
//                           title="Edit Blog"
//                         >
//                           <svg className="ptblgbtnIcon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                             <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
//                           </svg>
//                         </button>
//                         <button 
//                           //style={styles.deleteBtn}
//                           className="ptblgdeleteBtn"
//                           onClick={(e) => handleDeleteBlog(blg._id)}
//                           title="Delete Blog"
//                         >
//                           <svg className="ptblgbtnIcon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                             <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
//                           </svg>
//                         </button>
//                       </div>
//                     </div>
//                      <p className="ptblgcardDescription">{blg.description}</p>
//             <p className="ptblgcardDescription">{blg.date}</p>
//                   </div>
//                 </div>
//               ))}
//             </div>
//           )}
   


//            {editingBlog && (
//   <div className="ptblgmodalOverlay">
//       <div className="ptblgmodalContent">
//       <h2>Edit Blog Details</h2>
//       <img
//         src={editingBlog.imageUrl}
//         alt={editingBlog.title}
//         style={{ width: '100%', borderRadius: '10px', marginBottom: '1rem' }}
//       />
//       <div>
//         <label className="ptblglabel">Title</label>
//         <input
//           type="text"
//           value={editedTitle}
//           onChange={(e) => setEditedTitle(e.target.value)}
//          className="ptblginput"
//         />
//       </div>
//       <div>
//         <label className="ptblglabel">Description</label>
//         <textarea
//           value={editedDescription}
//           onChange={(e) => setEditedDescription(e.target.value)}
//           //style={styles.textarea}
//           className="ptblginput"
//         />
//       </div>
//        <div className="ptblgmodalActions">
//           <button className="ptblgsaveBtn" onClick={handleSaveEdit}>
//             Save
//           </button>
//           <button
//             className="ptblgcancelBtn"
//             onClick={() => setEditingBlog(null)}
//           >
//             Cancel
//           </button>
//         </div>
//     </div>
//   </div>
// )}
//     </Box>
//   )};

//  const styles = {
//    container: {
//     minHeight: '100vh',
//     //background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
//     padding: '2rem',
//   },
//   header: {
//     maxWidth: '1400px',
//     margin: '0 auto 2rem',
//     display: 'flex',
//     justifyContent: 'space-between',
//     alignItems: 'center',
//     flexWrap: 'wrap',
//     gap: '1rem',
//   },
//   pageTitle: {
//     fontSize: '2.5rem',
//     color: 'black',
//     fontWeight: '700',
//     margin: 0,
//     textShadow: '2px 2px 4px rgba(0, 0, 0, 0.2)',
//   },
//   addButton: {
//     background: 'white',
//     color: '#667eea',
//     border: 'none',
//     padding: '0.75rem 1.5rem',
//     borderRadius: '50px',
//     fontSize: '1rem',
//     fontWeight: '600',
//     cursor: 'pointer',
//     display: 'flex',
//     alignItems: 'center',
//     gap: '0.5rem',
//     transition: 'all 0.3s ease',
//     boxShadow: '0 4px 15px rgba(0, 0, 0, 0.2)',
//   },
//   icon: {
//     width: '20px',
//     height: '20px',
//   },
//   instructionBanner: {
//     maxWidth: '1400px',
//     margin: '0 auto 2rem',
//     background: 'rgba(255, 255, 255, 0.95)',
//     padding: '1rem 1.5rem',
//     borderRadius: '12px',
//     display: 'flex',
//     alignItems: 'center',
//     gap: '0.75rem',
//     boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
//     color: '#667eea',
//     fontSize: '0.95rem',
//     fontWeight: '500',
//   },
//   infoIcon: {
//     width: '24px',
//     height: '24px',
//     flexShrink: 0,
//   },
//   galleryGrid: {
//     maxWidth: '1400px',
//     margin: '0 auto',
//     display: 'grid',
//     gridTemplateColumns: 'repeat(auto-fill, minmax(350px, 1fr))',
//     gap: '2rem',
//   },
//   galleryCard: {
//     background: 'white',
//     borderRadius: '16px',
//     overflow: 'hidden',
//     boxShadow: '0 10px 30px rgba(0, 0, 0, 0.2)',
//     transition: 'all 0.3s ease',
//     border: '2px solid transparent',
//     position: 'relative',
//   },
//   imageWrapper: {
//     position: 'relative',
//     width: '100%',
//     height: '250px',
//     overflow: 'hidden',
//     background: '#f3f4f6',
//   },
//   galleryImage: {
//     width: '100%',
//     height: '100%',
//     borderRadius:'10px',
//     objectFit: 'cover',
//     transition: 'transform 0.3s ease',
//   },
//   cardContent: {
//     padding: '1.5rem',
//   },
//   cardHeader: {
//     display: 'flex',
//     justifyContent: 'space-between',
//     alignItems: 'flex-start',
//     marginBottom: '0.75rem',
//     gap: '1rem',
//   },
//   cardTitle: {
//     fontSize: '1.5rem',
//     color: '#1f2937',
//     fontWeight: '600',
//     margin: 0,
//     flex: 1,
//   },
//   actionButtons: {
//     display: 'flex',
//     gap: '0.5rem',
//     flexShrink: 0,
//   },
//   editBtn: {
//     width: '36px',
//     height: '36px',
//     background: '#3b82f6',
//     color: 'white',
//     border: 'none',
//     borderRadius: '8px',
//     cursor: 'pointer',
//     display: 'flex',
//     alignItems: 'center',
//     justifyContent: 'center',
//     transition: 'all 0.2s ease',
//   },
//   deleteBtn: {
//     width: '36px',
//     height: '36px',
//     background: '#ef4444',
//     color: 'white',
//     border: 'none',
//     borderRadius: '8px',
//     cursor: 'pointer',
//     display: 'flex',
//     alignItems: 'center',
//     justifyContent: 'center',
//     transition: 'all 0.2s ease',
//   },
//   btnIcon: {
//     width: '18px',
//     height: '18px',
//   },
//   cardDescription: {
//     color: '#6b7280',
//     lineHeight: '1.6',
//     fontSize: '0.95rem',
//     margin: 0,
//   },
//   emptyState: {
//     maxWidth: '1400px',
//     margin: '4rem auto',
//     textAlign: 'center',
//     background: 'white',
//     padding: '4rem 2rem',
//     borderRadius: '16px',
//     boxShadow: '0 10px 30px rgba(0, 0, 0, 0.2)',
//   },
//   emptyIcon: {
//     width: '80px',
//     height: '80px',
//     margin: '0 auto 1.5rem',
//     color: '#9ca3af',
//   },
//   emptyTitle: {
//     fontSize: '1.5rem',
//     color: '#1f2937',
//     marginBottom: '0.5rem',
//   },
//   emptyText: {
//     color: '#6b7280',
//     fontSize: '1rem',
//   },
//   modalOverlay: {
//   position: 'fixed',
//   top: 0,
//   left: 0,
//   width: '100%',
//   height: '100%',
//   margin: '0 auto',
//   // backgroundColor: 'rgba(0,0,0,0.6)',
//   display: 'flex',
//   alignItems: 'center',
//   justifyContent: 'center',
//   zIndex: 1000,
// },
// modalContent: {
//   backgroundColor: 'white',
//   borderRadius: '12px',
//   padding: '2rem',
//   width: '90%',
//   maxHeight: '80vh', // prevents it from going full height
//   overflowY: 'auto', // scroll only inside modal if needed
//   maxWidth: '500px',
//   boxShadow: '0 10px 25px rgba(0,0,0,0.3)',
// },
// label: {
//   display: 'block',
//   marginBottom: '0.5rem',
//   fontWeight: '600',
//   color: '#374151',
// },
// input: {
//   width: '100%',
//   padding: '0.5rem',
//   marginBottom: '1rem',
//   borderRadius: '8px',
//   border: '1px solid #d1d5db',
// },
// textarea: {
//   width: '100%',
//   padding: '0.5rem',
//   minHeight: '80px',
//   marginBottom: '1rem',
//   borderRadius: '8px',
//   border: '1px solid #d1d5db',
// },
// modalActions: {
//   display: 'flex',
//   justifyContent: 'flex-end',
//   gap: '1rem',
// },
// saveBtn: {
//   backgroundColor: '#3b82f6',
//   color: 'white',
//   border: 'none',
//   padding: '0.5rem 1rem',
//   borderRadius: '8px',
//   cursor: 'pointer',
//   fontWeight: '600',
// },
// cancelBtn: {
//   backgroundColor: '#e5e7eb',
//   color: '#374151',
//   border: 'none',
//   padding: '0.5rem 1rem',
//   borderRadius: '8px',
//   cursor: 'pointer',
//   fontWeight: '600',
// },

// };

// const styles = {

// contentCard: {
//     backgroundColor: 'white',
//     borderRadius: '8px',
//     boxShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.05)',
//     border: '1px solid #e5e7eb',
//     padding: '24px',
//     marginBottom: '24px'
//   },
//   cardHeader: {
//     display: 'flex',
//     justifyContent: 'space-between',
//     alignItems: 'center',
//     marginBottom: '16px'
//   },
//   cardTitle: {
//     fontSize: '18px',
//     fontWeight: '600',
//     margin: 0
//   },
//   primaryButton: {
//     padding: '8px 16px',
//     backgroundColor: '#2563eb',
//     color: 'white',
//     border: 'none',
//     borderRadius: '8px',
//     cursor: 'pointer',
//     fontSize: '14px',
//     fontWeight: '500'
//   },
//    blogPost: {
//     borderLeft: '4px solid #3b82f6',
//     paddingLeft: '16px',
//     paddingTop: '8px',
//     paddingBottom: '8px',
//     marginBottom: '12px'
//   },
//   blogTitle: {
//     fontWeight: '500',
//     margin: '0 0 4px 0'
//   },
//   blogMeta: {
//     fontSize: '14px',
//     color: '#6b7280',
//     margin: 0
//   },
// }


export default PostedBlogs;